var Theme = Theme || {};
Theme.Utilities = Theme.Utilities || {};

Theme.Utilities.Cadmore = (function ($) {
    var scriptLoaded = false;

    return {
        init: _init,
        loadCadmoreVideos: _loadCadmoreVideos
    };

    function _init() {
        initCadmoreVideos($('.js-cadmore-embed-placeholder'));
    }

    function initCadmoreVideos($cadmoreVideos) {
        if ($cadmoreVideos.length) {
            var accessCodes = $('.js-cadmore-data').data('videoaccess');
            var embedTemplate = $('.js-cadmore-data').data('embedformat');
            var scriptSource = $('.js-cadmore-data').data('embedsource');
            var useEmbedTemplate = $('.js-cadmore-data').data('useembedformat');

            $cadmoreVideos.each(function () {
                initCadmoreVideo($(this), accessCodes, embedTemplate, useEmbedTemplate);
            });

            loadCadmoreJs(scriptSource);
        }
    }

    function _loadCadmoreVideos($cadmoreContainer, cadmoreData) {
        if (!$cadmoreContainer.length || !cadmoreData) {
            return;
        }

        var $cadmorePlaceHolders = $cadmoreContainer.find('.js-cadmore-embed-placeholder');
        if (!$cadmorePlaceHolders.length) {
            return;
        }

        var accessCodes = cadmoreData.accessCodes;
        var embedtemplate = cadmoreData.embedtemplate;
        var embedScriptSource = cadmoreData.embedsource;
        var useEmbedTemplate = cadmoreData.useEmbedTemplate;

        $cadmorePlaceHolders.each(function () {
            initCadmoreVideo($(this), accessCodes, embedtemplate, useEmbedTemplate);
        });

        loadCadmoreJs(embedScriptSource);
    }  

    function loadCadmoreJs(scriptsource) {
        if (!scriptLoaded) {
            $.getScript(scriptsource);
            scriptLoaded = true;
        }
    }

    function getAccessCode(accessCodes, videoId) {
        if (!accessCodes || !Array.isArray(accessCodes)) {
            return null;
        }
        return accessCodes
            .filter(function (x) { return x.id == videoId; })
            .map(function (x) { return x.access; })
            .shift();
    }

    function initCadmoreVideo($contentPlaceholder, accessCodes, embedtemplate, useEmbed) {
        const videoId = $contentPlaceholder.data('cadmoreid');
        const accessCode = getAccessCode(accessCodes, videoId);

        if (!accessCode) {
            return;
        }

        if (useEmbed.toLowerCase() === 'true') {
            embedtemplate = embedtemplate.replace('{altId}', videoId);
            embedtemplate = embedtemplate.replace('{accessCode}', accessCode);
            $contentPlaceholder.html(embedtemplate);
        } else {
            const $iframe = $contentPlaceholder.find('iframe');
            let url = new URL($iframe.attr('src'));
            url.searchParams.append('token', accessCode);
            $iframe.attr('src', url.toString());
        }
    }
})(jQuery);